export default {
  SPOTIFY_CLIENT_ID: '492fbed0efbe4333a704835cc332a305',
};



// WEBPACK FOOTER //
// ./src/env.js